import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import api from '../../seller-apis/api';
import { pendingProducts, pendforapprovProducts } from '../../seller-apis/apidataField'
import { useAlert } from 'react-alert';

function Verification(props) {
	const alert = useAlert()
	const history = useHistory();

	const [otp, setotp] = useState(null);
	const [resendOtpDiv, setresendOtpDiv] = useState("none");
	const [otpstatus, setotpstatus] = useState("none")
	const mobileNo = props.match.params.mobile

	const [show, setShow] = useState(false)
	const [otpBlank, setOtpBlank] = useState(false)
	const [msg, setMsg] = useState("")
	const [msgTitle, setmsgTitle] = useState("")
	const [isVerifyingOtp, setIsVerifyingOtp] = useState(false)

	useEffect(() => {
		var referrer = document.referrer;
		if (referrer) {
			if (referrer.includes("google")) {
				history.replace("/login");
				return false;
			}
		}
		var timerId = setInterval(countdown, 1000);
		var timeLeft = 30;
		function countdown() {
			var elem = document.getElementById('OtpTimer');
			if (timeLeft === 0) {
				clearTimeout(timerId);
				elem.style.display = "none"
				setresendOtpDiv("block")

			} else {
				timeLeft--;
				elem.innerHTML = timeLeft;
			}
		}

		return () => clearTimeout(timerId);
	}, [])

	function handleKeyPress(event) {
		if (event.charCode === 13) {
			if (isVerifyingOtp) return;
			verifyOtp();
		}
	}

	const getStepobject = (data, compArray) => {

		for (var i = 0, iLen = compArray.length; i < iLen; i++) {

			if (compArray[i].name == data) {
				return compArray[i].value;
			}
			// return false;
		}
	}

	function verifyOtp() {
		if (isVerifyingOtp) return;
		setOtpBlank(false);
		if (!otp) {
			console.log("otp", otp)
			setOtpBlank(true);
		}
		else {
			let data = {
				"phoneNumber": mobileNo,
				"otp": otp
			}
			setIsVerifyingOtp(true);
			api.auth.verifyOtp(data)
				.then((res) => {
					// console.log(res)
					if (res.message === "Enter Correct OTP") {
						setotpstatus("block")
					}
					else {
						if(res?.action === "addProducts"){
							localStorage.setItem("lead",res?._id)
							history.push('/register/step2')
							return;
						}
						if (res.user && res.user.activeState && res.user.activeState === "InActive") {
							setmsgTitle("Account Suspended!")
							setMsg(`<span>Dear Seller, your account is currently suspended!</span></br><span>Please contact seller support team.</span>`)
							setShow(true)
						}
						else {
							localStorage.setItem('token', res.token);
							localStorage.setItem('name', res.user.name);
							localStorage.setItem('image', res.user.avatar);
							localStorage.setItem('phone', res.user.phoneNumber)
							localStorage.setItem('userId', res.user._id)
							localStorage.setItem('email', res.user.email)
							localStorage.setItem("vendorId", res.user._id)
							localStorage.setItem('gst', res.user.gstNo)
							localStorage.setItem('vendorType', res.user.vendorType ? res.user.vendorType : undefined)
							let res1 = res;
							localStorage.setItem('vendorState', res.user.activeState)
							api.auth.me({}).then(res => {
								if (res.message === "Seller Not Activated") {

									let totalPro = 0
									// Pending products
									let filter = {
										"pageNo": "1",
										"size": 1
									}

									if (getStepobject('step1', res1.user.profileStepsCompleted) && getStepobject('step2', res1.user.profileStepsCompleted) && getStepobject('step3', res1.user.profileStepsCompleted)) {
										api.product.newProductsRetrieveall(pendingProducts(filter))
											.then((res) => {
												totalPro = totalPro + res.totalRecords

												// New request for approval Products
												api.product.vExPrdReqRetrieveAll(pendforapprovProducts(filter))
													.then((res) => {
														totalPro = totalPro + res.totalRecords
														if (totalPro > 0) {
															// console.log('pro',totalPro)
															window.history.pushState({}, null, '/profile');
															window.location.assign('/home')
														}
														else {
															window.history.pushState({}, null, '/products');
															window.location.assign('/products');
														}
													})
													.catch(err => console.log(err))
											})
											.catch(err => console.log(err))
									}
									else {
										window.history.pushState({}, null, '/profile');
										window.location.assign('/profile')
									}
								}
								else if (res.message === "seller fetched") {
									window.history.pushState({}, null, '/home');
									window.location.assign('/home');
								}
							}).catch(err => console.log(err));
						}
					}
				}).catch(err => {
					const statusCode = err?.response?.status;
					if (statusCode === 400) {
						alert.error("Otp expired, please login again to receive new OTP");
						setTimeout(() => {
							window.location.assign('/login')
						}, 2000);
					}
					else{
						alert.error("Something went wrong, please try again later");
					}
				}).finally(() => {
					setIsVerifyingOtp(false);
				})
		}
	}

	function resendOtp() {
		let data = {
			"phoneNumber": mobileNo
		}
		api.auth.login(data)
			.then((res) => {
				if (res.message === "Otp Sent ") {
					window.location.assign('/verification/' + mobileNo);
				}
			}).catch((err) => console.log(err))
	}

	return (
		<div className="p-0  bg-theme">
			<div className="container h-500">
				<div class="d-flex justify-content-center align-items-center container">
					<div class="card card-otp py-5 px-3">
						<h5 class="m-0 v-top">Mobile phone verification</h5>
						<span className="mobile-text">Please enter the verification code sent to <b>{mobileNo}</b></span>
						{/* timer */}
						<span className="text-center f-500 text-white mt-1" id="OtpTimer"></span>
						<div class="d-flex flex-row mt-5">
							<input type="text" class="form-control" minLength="0"
								onChange={(e) => {
									setotp((v) => (e.target.validity.valid ? e.target.value : v));
								}}
								value={otp}
								pattern="[0-9]*"
								maxLength={4}
								onWheel={(e) => e.target.blur()} onKeyPress={handleKeyPress} />

						</div>
						<div className="text-center mt-5">
							<button
								type="button"
								class="btn btn-lg btn-block verify-Btn"
								onClick={() => verifyOtp()}
								disabled={isVerifyingOtp}
							>
								{isVerifyingOtp ? "Verifying..." : "Verify"}
							</button>

						</div>
						<div class="text-center mt-5" style={{ "display": otpstatus }}><span class="d-block mobile-text verify-s-Alerts">Please enter correct OTP</span></div>
						{otpBlank && <div class="text-center mt-5"><span class="d-block mobile-text verify-s-Alerts">Please enter OTP</span></div>}
						<div class="text-center mt-5" style={{ "display": resendOtpDiv }}>
							<span class="d-block mobile-text verify-s-Alerts">Didn't receive the code<i class="fa fa-question" aria-hidden="true"></i>
							</span><span class="font-weight-bold cursor verify-span-resend" onClick={resendOtp}>Resend</span></div>
					</div>

				</div>
			</div>
			<Modal
				size="lg"
				aria-labelledby="contained-modal-title-vcenter"
				centered
				show={show}
				onHide={() => setShow(false)}
			>
				<Modal.Body className='my-5 text-center'>
					<h5 className='ff_Pop'>{msgTitle}</h5>
					<p className='title fs-15 text-danger ff_Pop' dangerouslySetInnerHTML={{ __html: msg }}>
					</p>
					{/* <NavLink className='text-danger' exact to="/profile"><button className='m-2 btn_verify_home_gsttan py-1 '>Reverify</button></NavLink> */}
				</Modal.Body>

			</Modal>
		</div>
	)
}

export default Verification;